import { is } from '../is';

export function generateAssetsList(schema) {
  const assets = new Set(schema.assets);
  for (const widgetId in schema.widgets) {
    const widget = schema.widgets[widgetId];

    if (widget.type === 'image') {
      assets.add(widget.url);
    }

    if (is.widget.slider(widget) && widget.thumbImageUrl) {
      assets.add(widget.thumbImageUrl);
    }
  }

  for (const bgId in schema.backgrounds) {
    const bg = schema.backgrounds[bgId];

    if (bg?.type === 'image') {
      assets.add(bg.data);
    }
  }

  schema.assets = [...assets];
  return schema;
}
